import React from 'react';
import { ButtonWrapper } from './ActionButton.styles';
import { ApButtonSecondary, colors } from '@alixpartners/ui-components';

const ActionButton = ({ label, onClick }) => {
	return (
		<ButtonWrapper>
			<ApButtonSecondary
				small={true}
				iconProps={{ iconColor: colors.grey8, material: true }}
				onClick={onClick}
			>
				{label}
			</ApButtonSecondary>
		</ButtonWrapper>
	);
};

export default ActionButton;
